import { Box, Typography } from '@mui/material';
import { SectionHeader } from './SectionHeader';
import { globalSupplyChainClause } from './clauseContent';

export default function GlobalSupplyChainClause() {
  return (
    <>
      <SectionHeader>
        <Typography variant="subtitle1">{globalSupplyChainClause.heading}</Typography>
      </SectionHeader>
      <Box
        sx={{
          p: 2,
          mb: 2,
          '@media print': {
            pageBreakInside: 'avoid',
            breakInside: 'avoid',
            pageBreakBefore: 'avoid',
            breakBefore: 'avoid',
          },
        }}
      >
        {globalSupplyChainClause.bullets?.map((bullet, index) => (
          <Typography
            key={index}
            variant="body2"
            sx={{
              fontSize: '11px',
              mb: index < (globalSupplyChainClause.bullets?.length || 0) - 1 ? 1 : 0,
            }}
          >
            • {bullet}
          </Typography>
        ))}
      </Box>
    </>
  );
}
